import { useAppSelector } from '../app-state/Hooks';
/**
 * `useCurrencySymbol` returns the current currency symbol for the active site.
 *
 * It selects the symbol from app configuration state via `selectCurrencySymbol`.
 */
import { selectCurrencySymbol } from '../app-state/selectors/config';

export const useCurrencySymbol = () => useAppSelector(selectCurrencySymbol);
